/**
 * Turn a human name into a URL/doc-id-friendly slug.
 *
 * 'Cork Week 2026' -> 'cork-week-2026'
 * 'Crosshaven Régatta!' -> 'crosshaven-regatta'
 *
 * Lowercases, strips diacritics, replaces any run of non-alphanumeric
 * characters with a single hyphen, and trims leading/trailing hyphens.
 * Used to auto-suggest season/event IDs from the entered name (ra-gbrd.4).
 */
export function slugify(name) {
  if (!name) return '';
  return String(name)
    .normalize('NFKD') // split accented chars into base + combining mark
    .replace(/[̀-ͯ]/g, '') // drop the combining marks
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-') // any non-alphanumeric run -> single hyphen
    .replace(/^-+|-+$/g, ''); // trim leading/trailing hyphens
}
